<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <loading
        :active.sync="isLoading"
        :can-cancel="true"
        :on-cancel="onCancel"
        :is-full-page="fullPage"
      ></loading>

      <b-card class="mb-0">
        <b-link class="brand-logo">
          <b-img fluid :src="sideImg" />
        </b-link>

        <b-card-title class="mb-1"> ข้อมูลร้านค้า </b-card-title>
        <b-card-text class="mb-2">
          กรอกข้อมูลร้านค้าเพื่อเข้าร่วมเป็นส่วนหนึ่งของพร้อมสั่ง
          และขายสินค้าต่างๆ จากร้านของคุณได้เลย
        </b-card-text>

        <!-- form -->
        <validation-observer ref="registerForm">
          <b-form
            class="auth-register-form mt-2"
            @submit.prevent="validationForm"
          >
            <b-form-group label="ชื่อร้านค้า" label-for="shopName">
              <validation-provider
                #default="{ errors }"
                name="Shop Name"
                rules="required"
              >
                <b-form-input
                  id="shopName"
                  v-model="shopName"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="เบอร์โทรศัพท์" label-for="shopPhone">
              <validation-provider
                #default="{ errors }"
                type="phone"
                name="Shop Phone"
                rules="required"
              >
                <b-form-input
                  id="shopPhone"
                  v-model="shopPhone"
                  :state="errors.length > 0 ? false : null"
                  :disabled="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="อีเมล" label-for="shopEmail">
              <validation-provider
                #default="{ errors }"
                name="Shop Email"
                rules="required"
              >
                <b-form-input
                  id="shopEmail"
                  v-model="shopEmail"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="เลขบัตรประชาชน" label-for="citizenId">
              <validation-provider
                #default="{ errors }"
                name="CitizenId"
                rules="required|digits:13"
              >
                <b-form-input
                  id="citizenId"
                  v-model="citizenId"
                  type="number"
                  :state="errors.length > 0 ? false : null"
                  @input="checkId"
                />
                <small class="text-danger" v-if="isCheckId"
                  >เลขบัตรประชาชนไม่ถูกต้อง</small
                >
              </validation-provider>
            </b-form-group>

            <b-form-group label="รายละเอียด" label-for="description">
              <validation-provider
                #default="{ errors }"
                name="Description"
                rules="required"
              >
                <b-form-input
                  id="description"
                  v-model="description"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="ประเภทร้านค้า" label-for="shopType">
              <validation-provider
                #default="{ errors }"
                name="Shop Type"
                rules="required"
              >
                <v-select
                  v-model="shopType"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="shopTypeOptions"
                  :reduce="(val) => val.value"
                  :clearable="false"
                  :state="errors.length > 0 ? false : null"
                  label="label"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="ที่อยู่" label-for="addressLine1">
              <validation-provider
                #default="{ errors }"
                name="addressLine1"
                rules="required"
              >
                <b-form-input
                  id="addressLine1"
                  v-model="addressLine1"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="จังหวัด" label-for="shopType">
              <validation-provider
                #default="{ errors }"
                name="Shop Type"
                rules="required"
              >
                <v-select
                  v-model="provinceSelect"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="provinceOptions"
                  :clearable="false"
                  :state="errors.length > 0 ? false : null"
                  label="label"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="อำเภอ" label-for="shopType">
              <validation-provider
                #default="{ errors }"
                name="Shop Type"
                rules="required"
              >
                <v-select
                  v-model="districtSelect"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="districtOptions"
                  :clearable="false"
                  :state="errors.length > 0 ? false : null"
                  label="label"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="ตำบล" label-for="shopType">
              <validation-provider
                #default="{ errors }"
                name="Shop Type"
                rules="required"
              >
                <v-select
                  v-model="subDistrictSelect"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="subDistrictOptions"
                  :clearable="false"
                  :state="errors.length > 0 ? false : null"
                  label="label"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <div>
              <GmapMap
                :center="center"
                :zoom="18"
                map-style-id="roadmap"
                :options="mapOptions"
                style="width: 100%; height: 50vmin"
                ref="mapRef"
                @click="handleMapClick"
              >
                <GmapMarker
                  :position="marker.position"
                  :clickable="true"
                  :draggable="true"
                  @drag="handleMarkerDrag"
                  @click="panToMarker"
                />
              </GmapMap>
              <b-button variant="success" style="margin-top: 0.5rem; margin-bottom: 0.5rem; width: 100%;" @click="geolocate">ตำแหน่งปัจจุบัน</b-button>
              <p>Selected Position: {{ marker.position }}</p>
            </div>

            <div v-if="isError" style="color: red">
              {{ isErrorMessage }}
            </div>

            <!-- submit button -->
            <b-button variant="primary" block type="submit"> ต่อไป </b-button>
          </b-form>
        </validation-observer>
      </b-card>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BForm,
  BImg,
  BButton,
  BFormInput,
  BFormGroup,
} from "bootstrap-vue";
import { required, digits } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import { ref, onUnmounted } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store/index";
import authenStoreModule from "./authenStoreModule";
import router from "@/router";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    // BSV
    BCard,
    BLink,
    BCardTitle,
    BCardText,
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BImg,
    vSelect,
    // validations
    ValidationProvider,
    ValidationObserver,
    Loading,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      // eslint-disable-next-line global-require
      sideImg: require("@/assets/images/logo/logo.png"),
      shopName: "",
      shopPhone: router.currentRoute.params.phone,
      shopEmail: router.currentRoute.params.email,
      description: "",
      shopType: "",
      // validation rules
      required,
      digits,
      provinceSelect: {},

      districtSelect: {},

      subDistrictSelect: {},
      postalCode: "",
      contactName: "",
      phone: "",
      addressLine1: "",
      citizenId: "",
      isError: false,
      isErrorMessage: "",
      isLoading: false,
      fullPage: true,
      isCheckId: false,
      marker: { position: { lat: 10, lng: 10 } },
      center: { lat: 10, lng: 10 },
      mapOptions: {
        disableDefaultUI: true,
      },
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  setup() {
    // Register module
    if (!store.hasModule("authen"))
      store.registerModule("authen", authenStoreModule);

    // // UnRegister on leave
    // onUnmounted(() => {
    //   if (store.hasModule('authen')) store.unregisterModule('authen')
    // })

    const shopTypeOptions = ref([{ value: "", label: "" }]);

    store
      .dispatch("authen/getShopTypes")
      .then((response) => {
        if (response !== null) {
          response.data.data.forEach((data) => {
            shopTypeOptions.value.push({
              value: data.shopTypeId,
              label: data.shopTypeName,
            });
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });

    const provinceOptions = ref([
      {
        label: "กรุณาเลือกจังหวัด",
        value: null,
      },
    ]);

    store
      .dispatch("authen/postProvince")
      .then((response) => {
        if (response !== null) {
          response.data.data.forEach((data) => {
            provinceOptions.value.push({
              value: data.province_Code,
              label: data.province_Name_TH,
            });
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    const districtOptions = ref([
      {
        label: "กรุณาเลือกอำเภอ",
        value: null,
      },
    ]);
    const subDistrictOptions = ref([
      {
        label: "กรุณาเลือกตำบล",
        value: null,
      },
    ]);

    return {
      shopTypeOptions,
      provinceOptions,
      districtOptions,
      subDistrictOptions,
    };
  },
  watch: {
    provinceSelect: function () {
      this.getDistict(this.provinceSelect);
    },
    districtSelect: function () {
      this.postSubDistrict(this.provinceSelect, this.districtSelect);
    },
    subDistrictSelect: function () {
      this.postalCode = this.subDistrictSelect.postalCode;
    },
  },
  methods: {
    //detects location from browser
    geolocate() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.marker.position = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        this.panToMarker();
      });
    },
    //sets the position of marker when dragged
    handleMarkerDrag(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    },
    //Moves the map view port to marker
    panToMarker() {
      this.$refs.mapRef.panTo(this.marker.position);
      this.$refs.mapRef.setZoom(18);
    },
    //Moves the marker to click position on the map
    handleMapClick(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    },
    ScriptCheckID(id) {
      if (id.substring(0, 1) == 0) return false;
      if (id.length != 13) return false;
      let value = false;
      for (let i = 0, sum = 0; i < 12; i++) {
        sum += parseFloat(id.charAt(i)) * (13 - i);
        if ((11 - (sum % 11)) % 10 != parseFloat(id.charAt(12))) {
          value = false;
        } else {
          value = true;
        }
      }
      return value;
    },
    checkId() {
      this.isCheckId = !this.ScriptCheckID(this.citizenId);
    },
    getDistict(province) {
      store
        .dispatch("authen/postDistrict", province.value)
        .then((response) => {
          if (response !== null) {
            this.districtOptions = [
              {
                label: "กรุณาเลือกอำเภอ",
                value: null,
              },
            ];

            this.postalCode = "";
            this.districtSelect = {};
            this.subDistrictSelect = {};
            response.data.data.forEach((data) => {
              this.districtOptions.push({
                value: data.district_Code,
                label: data.district_Name_TH,
              });
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    postSubDistrict(province, district) {
      let payload = {
        province: province.value,
        district: district.value,
      };

      store
        .dispatch("authen/postSubDistrict", payload)
        .then((response) => {
          if (response !== null) {
            this.subDistrictOptions = [
              {
                label: "กรุณาเลือกตำบล",
                value: null,
              },
            ];
            this.subDistrictSelect = {};
            this.postalCode = "";
            response.data.data.forEach((data) => {
              this.subDistrictOptions.push({
                value: data.subdistrict_Code,
                label: data.subdistrict_Name_TH,
                postalCode: data.postal_Code,
              });
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onCancel() {
      console.log("User cancelled the loader.");
    },

    validationForm() {
      this.$refs.registerForm.validate().then((success) => {
        if (success) {
          this.isLoading = true;
          const registerModel = {
            shopId: "00000000-0000-0000-0000-000000000000",
            shopName: this.shopName,
            description: this.description,
            shopTypeId: this.shopType !== null ? this.shopType : '',
            // shopTypeName: this.shopType !== null ? this.shopType.label : "",
            address: [
              {
                addressId: "00000000-0000-0000-0000-000000000000",
                userAddressId: "00000000-0000-0000-0000-000000000000",
                contactName: this.shopName,
                phone: this.shopPhone,
                addressLine1: this.addressLine1,
                isDefault: true,
                updatedOn: new Date(),
                addressLine2: "",
                moo: "",
                soi: "",
                road: "",
                tumbon: this.subDistrictSelect.label,
                amphur: this.districtSelect.label,
                province: this.provinceSelect.label,
                zipCode: this.postalCode,
                email: this.shopEmail,
                citizenId: this.citizenId,
                latitude: this.marker.position.lat.toString(),
                longitude: this.marker.position.lng.toString(),
              },
            ],
          };

          store
            .dispatch("authen/registerShop", registerModel)
            .then((response) => {
              if (response.status === 200) {
                this.isLoading = false;
                this.$router.push({ name: "auth-register-payment" });
              } else {
                this.isLoading = false;
                this.isError = true;
                this.isErrorMessage = response.data.message;
              }
            })
            .catch((error) => {
              this.isLoading = false;
              console.log(error);
            });
        }
      });
    },
  },
  mounted() {
    this.geolocate();
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
